$(document).ready(function() {

    let fadeInElement;

    $('.mod24TabbedBubbles .tabs li').on('click', function() {
        const $this = $(this);
        const wrapper = $this.closest('.mod24TabbedBubbles');

        $('.tabs li', wrapper).removeClass('active');
        $this.addClass('active');

        fadeInElement = $('.mod24TabbedBubbles .tab.' + $this.data('tab'));

        $('.tab', wrapper).is(':visible').fadeOut('fast', function() {
            fadeInElement.fadeIn('fast');
        });
    });
});
